import { action, observable } from 'mobx';
import { setMap } from './Array';
import { HttpClient, IConfig } from './HttpClient';
import { humanizeString } from './HumanizeString';

export interface ICreateMetaModel {
    forms: any[];
    fields: {
        [id: number]: any;
    };
    tags: string[];
}

export class TicketsStore {
    public constructor(httpClient: HttpClient, fieldIds: { [id: string]: number }) {
        this.httpClient = httpClient;
        this.fieldIds = fieldIds;
    }

    @action
    public async loadCreateMetaAsync() {
        this.createMeta = await this.httpClient.get<ICreateMetaModel>(`/api/v1/tickets/create-meta`, {
            cache: true,
        });

        console.log('Meta load: ' + this.createMeta);
    }

    @action
    public async createAsync(model: any) {
        const result = await this.httpClient.post<{ id: any }>(`/api/v1/tickets`, model);

        if (result) return result.id;
    }

    // TODO how to not use any when having common code between internal & portal, with different models???
    @action
    public async loadTicketsAsync(model: any, config?: IConfig) {
        const tickets = await this.httpClient.post<Mri.Tickets.Ticket[]>(`/api/v1/tickets/search`, model, config);

        if (tickets) {
            //for (const ticket of tickets) {
            //    ticket.tags = ticket.tags.map((t: string) => (t = humanizeString(t)));
            //}

            setMap(this.tickets, tickets, t => t.ticketId);
        }
    }

    public formField(s: string) {
        return this.fieldIds[s.toLowerCase()] as number;
    }

    @observable
    public createMeta?: ICreateMetaModel;
    @observable
    public tickets = new Map<string, Mri.Tickets.Ticket>();

    private readonly fieldIds: { [id: string]: number };
    private readonly httpClient: HttpClient;
}
